// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13G9P","textarea":"styles_textarea__2SmEj"};